module.exports = __webpack_public_path__ + "img/fm.aaebcec4.svg";